
// import Animation from '@/components/animation'
import imgSrc1 from '~/assets/img/home/product_mb_new_01.svg'
import imgSrc2 from '~/assets/img/home/product_mb_new_02.svg'
import imgSrc3 from '~/assets/img/home/product_mb_new_03.png'

export default {
  components: {
    // Animation,
  },
  props: {
    clientData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      imgSrc1,
      imgSrc2,
      imgSrc3,
      current: {
        0: 0,
        1: 0,
      },
      product_wrap_imgUrl: '~/assets/img/home/product_mb_new_01.svg',
      // product_wrap_imgUrl: '/product_mb_new_01.svg',
      product_wrap_imgUrlList: [],
      activeTabs: 0,
      sonContent: [],
    }
  },
  computed: {
    lang() {
      return this.$route.params.lang
    },
  },
  mounted() {
    console.log('clientData---', this.clientData)
    this.product_wrap_imgUrlList = this.clientData[0].children.map((item) => {
      return item.img_mb
    })
    // this.product_wrap_imgUrlList = [
    //   '~/assets/img/home/product_mb_new_01.svg',
    //   '~/assets/img/home/product_bg_02.png',
    //   '~/assets/img/home/product_mb_new_03.png'
    // ]
    this.clickTab(this.clientData[0].children[0], 0)
    console.log('product_wrap_imgUrlList---', this.product_wrap_imgUrlList)
  },
  methods: {
    change(index, idx) {
      if (this.current[index] !== idx) {
        this.current[index] = idx
      }
    },
    clickTab(row, index) {
      console.log('sonContent', row)
      let children = row.children.filter((item) => {
        return item.subTitle
      })
      this.sonContent = { ...row, children }
      // this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      // if (index == 0) {
      //   this.product_wrap_imgUrl = imgSrc1
      // } else if (index == 1) {
      //   this.product_wrap_imgUrl = imgSrc2
      // } else if (index == 2) {
      //   this.product_wrap_imgUrl = imgSrc3
      // }
      console.log('product_wrap_imgUrl', this.product_wrap_imgUrl)

      const img = document.getElementById('main-image')
      img.style.opacity = 0 // 开始淡出，设置透明度为0
      setTimeout(() => {
        // img.src = this.product_wrap_imgUrlList[index]; // 更换图片源
        img.style.opacity = 1 // 图片源更换后，开始淡入，设置透明度为1
        this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      }, 500) // 延迟1秒后开始更换图片源，与CSS中的过渡时间相匹配

      // const leftImage = document.getElementById('left-image')
      // leftImage.style.left = '-40%' // 开始淡出，设置透明度为0
      // setTimeout(() => {
      //   // img.src = this.product_wrap_imgUrlList[index]; // 更换图片源
      //   leftImage.style.left = 0 // 图片源更换后，开始淡入，设置透明度为1
      //   this.product_wrap_imgUrl = this.product_wrap_imgUrlList[index]
      // }, 2000) // 延迟1秒后开始更换图片源，与CSS中的过渡时间相匹配
    },
    // setImg(){

    //   // return require('~/assets/img/home/product_mb_new_01.svg')
    //   console.log('this.product_wrap_imgUrl1111', '~/assets/img/home/product_mb_new_01.svg')
    //   console.log('this.product_wrap_imgUrl', this.product_wrap_imgUrl)
    //   // return require(this.product_wrap_imgUrl)
    //   return this.product_wrap_imgUrl
    // }
  },
}
